import AxiosInstance from '../config/AxiosInstance';
import AxiosInstanceFormData from '../config/AxiosInstanceFormData';

const listAppVersions = async (payload: {
  page?: number;
  limit?: number;
  searchValue?: string;
}) => {
  try {
    const { data } = await AxiosInstance.get('/api/inventory/app-versions', {
      params: {
        page: payload.page,
        limit: payload.limit,
        searchValue: payload.searchValue,
      },
    });
    return { data };
  } catch (error) {
    throw error;
  }
};

const getAppVersion = async (id: string) => {
  try {
    const { data } = await AxiosInstance.get(`/api/inventory/app-versions/${id}`);
    return { data };
  } catch (error) {
    throw error;
  }
};

const createAppVersion = async (formData: FormData) => {
  try {
    const { data } = await AxiosInstanceFormData.post('/api/inventory/app-versions', formData);
    return { data };
  } catch (error) {
    throw error;
  }
};

const updateAppVersion = async (id: string, formData: FormData) => {
  try {
    const { data } = await AxiosInstanceFormData.put(`/api/inventory/app-versions/${id}`, formData);
    return { data };
  } catch (error) {
    throw error;
  }
};

const deleteAppVersion = async (id: string) => {
  try {
    const { data } = await AxiosInstance.delete(`/api/inventory/app-versions/${id}`);
    return { data };
  } catch (error) {
    throw error;
  }
};

export {
  listAppVersions,
  getAppVersion,
  createAppVersion,
  updateAppVersion,
  deleteAppVersion,
};
